module.exports = __webpack_public_path__ + "img/29.d8bd26b0.jpg";